import { stdObject } from "../../../data/types/stdObject";
import { getPrefix } from "../../../utils/getPrefix";
import { getParamName } from "./getParamName";

export const arrangeDocData = (
  resultInfo: stdObject,
  dataPack: stdObject,
  writeDataParams: ({}: stdObject) => void,
) => {
  const { t, user, warehouses, statusDict, staffList } = dataPack;
  let newData: stdObject = { data: {}, staff: {} };

  Object.keys(resultInfo.data).forEach((e) => {
    const key = getPrefix(e);
    let active =
      key === "PRE"
        ? user[`${resultInfo.type}US1`] > 0
        : key === "PIM"
          ? user[`${resultInfo.type}IMPUS1`] > 0
          : true;

    const options =
      key === "ALM2"
        ? warehouses
            .filter(
              (v: stdObject) =>
                v.CODALM !==
                Number(
                  resultInfo.data[`COD${resultInfo.type}`] === 0
                    ? user.ALMSUC
                    : resultInfo.data[`ALM${resultInfo.type}`],
                ),
            )
            .map((v: stdObject) => {
              return { label: v.NOMALM, value: v.CODALM };
            })
        : null;

    if (key === "ALM2" && resultInfo.data[`COD${resultInfo.type}`] === 0) {
      resultInfo.data[`ALM${resultInfo.type}`] = user.ALMSUC;
      resultInfo.data[`ALM2${resultInfo.type}`] =
        options && options.length > 0 ? options[0].value : user.ALMSUC;
    }

    newData.data[e] = writeDataParams({
      type: resultInfo.type,
      key,
      value: key === "PSE" && !resultInfo.data[e] ? "" : resultInfo.data[e],
      itemCode: key === "PRE" ? resultInfo.data["INT" + resultInfo.type] : "",
      field: "data",
      active,
      options,
      name: getParamName({
        key,
        code: resultInfo.type,
        data: resultInfo.data,
        label: key === "PRE" ? t("c.IMP") : "",
        statusDict: key === "PAG" ? statusDict : {},
      }),
      hideCode: ["PAG", "PSE"].includes(key),
      paid:
        resultInfo.commissions && ["INT"].includes(key)
          ? resultInfo.commissions.some(
              (z: stdObject) => z.LINCOY === 0 && z.PAGCOY > 0,
            )
          : false,
    });
  });
  staffList
    .filter((e: stdObject) => resultInfo.type === e.DOCIA1)
    .forEach((e: stdObject) => {
      newData.staff[e.CODIA1] = writeDataParams({
        type: resultInfo.type,
        key: e.CODIA1,
        value: resultInfo.staff[e.CODIA1]?.AGEIA2 ?? "",
        field: "staff",
        name: resultInfo.staff[e.CODIA1]?.NOMIA2 ?? "",
        hideCode: true,
        paid: resultInfo.commissions
          ? resultInfo.commissions.some(
              (z: stdObject) =>
                z.AGECOY === resultInfo.staff[e.CODIA1]?.AGEIA2 &&
                z.GRUCOY === e.CODIA1 &&
                z.PAGCOY > 0,
            )
          : false,
      });
    });
  return { ...resultInfo, ...newData };
};
